var X={sizes:{XXS:"8px",XS:"12px",S:"14px",M:"16px",L:"20px",XL:"24px",XXL:"32px",XXXL:"48px"},sizesNumber:{XXS:8,XS:12,S:14,M:16,L:20,XL:24,XXL:32,XXXL:48}};export{X as default};
